import { useState } from "react";
import { iconData } from "../../../../iconData";
import MideaViewer from "../../../../midea_viewer/MideaViewer";
import { IP } from "./../../../../internalServer";
import { Card, IconButton, Typography, Box, Tooltip } from "@mui/material";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import VideoFileRoundedIcon from "@mui/icons-material/VideoFileRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { LinkIcon } from "lucide-react";

// all css comes in pdfType.css
const Attachment = ({ setAttach, newPreRead, attach, id, handleAttach }) => {
  const [mideaviewer, setMideaviewer] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);

  let attachments = attach;
  const attachformat = (para) => {
    if (para !== undefined) {
      const filePath = para;
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const extractedFileName = fileName.split("_")[1];
      return extractedFileName;
    }
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };
  console.log(attachments, "attachments");
  const ext = attachments.split(".").pop()?.toLowerCase() || "";
  console.log(ext, "ected");
  const isImage = ["jpg", "jpeg", "png"].includes(ext);
  const isVideo = ["mp4", "mov", "wmv", "mpeg"].includes(ext);
  const isPdf = ["pdf"].includes(ext);
  const isPpt = ["ppt", "pptx"].includes(ext);

  const isLink =
    attachments.startsWith("http://") || attachments.startsWith("https://");

  const handleOpen = () => {
    if (isLink) {
      window.open(attachments, "_blank"); // ✅ open in new tab
    } else if (isImage || isVideo) {
      handleClick(attachments);
    } else if (isPdf || isPpt) {
      handleClickforpdf(attachments);
    }
  };

  function generateLinkName(attachments) {
    if (!attachments.startsWith("https://")) {
      return "Invalid link";
    }

    // Get today’s date
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = today.getFullYear();

    // Format: link_dd-mm-yyyy
    const formattedDate = `${day}-${month}-${year}`;

    return `link_${formattedDate}`;
  }

  const getAttachmentName = (attachment) => {
    if (!attachment) return "";

    // If URL → generate readable name
    if (attachment.startsWith("https://")) {
      return generateLinkName(attachment);
    }

    // If file path → extract filename
    return attachment.split("/").pop().replace(/^\d+_/, "");
  };


  return (
    <>
      {/* <div
        className=" attachBox m-1 "
        onClick={() => {
          const fileType = attachments.split(".").pop();
          if (
            fileType === "jpg" ||
            fileType === "jpeg" ||
            fileType === "png" ||
            fileType === "mp4" ||
            fileType === "JPG" ||
            fileType === "JPEG" ||
            fileType === "PNG" ||
            fileType === "MP4"
          ) {
            handleClick(attachments);
          } else if (
            fileType === "pdf" ||
            fileType === "PDF" ||
            fileType === "ppt" ||
            fileType === "PPT" ||
            fileType === "PPTX" ||
            fileType === "pptx"
          ) {
            handleClickforpdf(attachments);
          }
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          {attachments.split(".").pop() === "jpg" ||
          attachments.split(".").pop() === "jpeg" ||
          attachments?.split(".").pop() === "JPEG" ||
          attachments?.split(".").pop() === "JPG" ||
          attachments?.split(".").pop() === "PNG" ||
          attachments?.split(".").pop() === "mp4" ||
          attachments?.split(".").pop() === "MP4" ||
          attachments.split(".").pop() === "png" ? (
            <div
              className="d-flex align-items-center"
              onClick={() => {
                if (!isError) {
                  handleClick(attachments);
                }
              }}
            >
              <>
                <div
                 
                  onClick={() => handleClick(attachments)}
                  className="ContainerUploadedPdf d-flex gap-2 p-1"
                >
                  <div className="d-flex align-items-center pdf_logo">
                    <img
                      src={`${
                        iconData?.find(
                          (i) => i.extension === attachments?.split(".").pop()
                        )?.icon
                      }`}
                      alt=""
                      className="mr-2 hw_defult_attach_type_icon"
                    />
                  </div>
                </div>
              </>
            </div>
          ) : (
            <div
              className="all_pdf_pre"
              onClick={() => handleClickforpdf(attachments)}
            >
              <div className="pdf_logo">
                <img
                  src={`${
                    iconData?.find(
                      (i) => i.extension === attachments?.split(".").pop()
                    )?.icon
                  }`}
                  alt=""
                  className="  attachLogoActivity"
                />
              </div>
            </div>
          )}
          <div>
            <div>
              <img
                src="/images/cross.svg"
                alt=""
                onClick={(e) => {
                  handleAttach(id, attach);
                }}
                style={{ float: "right" }}
              />
            </div>
            <div className="pdf_detail" style={{ marginLeft: "0px" }}>
              <div className=" d-flex align-itens-center justify-content-between">
                {newPreRead ? (
                  <span className="pdf-txt1">{newPreRead?.subject_name}</span>
                ) : null}
              </div>
            
              <div className="pdf-txt2" title={attachformat(attachments)}>
                {attachformat(attachments)}
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Card
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.2,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          backgroundColor: "#fafafa",
          cursor: "pointer",
          "&:hover": {
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            backgroundColor: "#fff",
          },
          mb: 1.5,
        }}
      >
        {/* Left Section: File Icon + Info */}
        <Box display="flex" alignItems="center" gap={2}>
          {/* Dynamic File Icon */}
          <Box
            sx={{
              width: 42,
              height: 42,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              borderRadius: 1.5,
              overflow: "hidden",
            }}
          >
            <img
              src={
                attachments.startsWith("http://") ||
                  attachments.startsWith("https://")
                  ? "/images/link-icon.png"
                  : iconData?.find(
                    (i) =>
                      i.extension.toLowerCase() ===
                      attachments?.split(".").pop()?.toLowerCase()
                  )?.icon || "/images/file-default.png"
              }
              alt=""
              className="attachLogoActivity"
            />
          </Box>

          {/* Text Info */}

          <Box>
            {newPreRead && (
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: "#333", mb: 0.3 }}
              >
                {newPreRead?.subject_name}
              </Typography>
            )}
            <Tooltip title={getAttachmentName(attachments)}>
              <Typography
                variant="body2"
                sx={{
                  color: "#555",
                  maxWidth: 80,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                }}
              >
                {getAttachmentName(attachments)}
              </Typography>
            </Tooltip>

          </Box>
        </Box>

        {/* Remove Button */}
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleAttach(id, attach);
          }}
        >
          <CloseRoundedIcon sx={{ color: "#b71c1c" }} />
        </IconButton>
      </Card>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
          responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  {/* {console.log("1st")} */}
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {/* {console.log("2nd")} */}
                  <img
                    onClick={() => {
                      handleClick();
                      setIsError(false);
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo-1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
              {/* <img
                className="imgMain"
                src={IP + responseAttach?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div> */}
            </div>
          </div>
        ))}
    </>
  );
};

export default Attachment;
